import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {DoodOrderModel} from '@store/order/order.model';
import {NeptingTerminalApiService,} from '@core/services/api/nepting-terminal/nepting-terminal-api.service';
import {IKioskHardwareNeptingTerminal, NeptingMerchantContract} from "@core/models/kiosk.model";


@Injectable({
  providedIn: 'root',
})
export class NeptingTerminalService {

  private _merchantContract: NeptingMerchantContract = NeptingMerchantContract.ERT10;

  constructor(private readonly neptingTerminalApi: NeptingTerminalApiService) {}

  setConfiguration(configuration: IKioskHardwareNeptingTerminal) {
    // this.merchantContract(configuration.merchantContract);
  }


  get merchantContract(): NeptingMerchantContract {
    return this._merchantContract;
  }

  abortTransaction$() {
    return this.neptingTerminalApi.abortTransaction$();
  }

  changeOrderStatusToPayment$(orderId: string, paymentRef: string): Observable<DoodOrderModel> {
    return this.neptingTerminalApi.changeOrderStatusToPayment$(orderId, paymentRef);
  }
}
